import axios from 'axios';

let pendingCounter = null;
let counterRequest = 0;

export default {
  state: {
    counterPushData: {},
    counterBasketData: {},
    counterFavoriteData: {},
    counterData: {},
    counter_loading: false,
    counter_error: null,
    counter_loaded: false
  },
  mutations: {
    SET_COUNTER_DATA(state, data) {
      data = data || {basket: {count: 0, ids: []}, favorite: {count: 0, ids: []}, push: {}};
      state.counterData = data;
      state.counterBasketData = data.basket;
      state.counterFavoriteData = data.favorite;
      state.counterPushData = data.push;
      state.loaded = true;
      state.counter_loaded = true;
    },
    SET_LOADING(state, status) {
      state.counter_loading = status;
    },
    SET_ERROR(state, error) {
      state.counter_error = error;
    },
    RESET_LOADED_STATE(state) {
      state.counter_loaded = false;
    },
    ADD_FAVORITE(state, id) {
      const ids = state.counterFavoriteData.ids || (state.counterFavoriteData.ids = []);
      if (!ids.includes(id)) { ids.push(id); }
    },
    ADD_BASKET(state, id) {
      const ids = state.counterBasketData.ids || (state.counterBasketData.ids = []);
      if (!ids.includes(id)) { ids.push(id); }
    },
    REMOVE_FAVORITE(state, id) {
      state.counterFavoriteData.ids = (state.counterFavoriteData.ids || []).filter(item => item !== id);
    }
  },
  actions: {
    async fetchCounterData({ commit, state }, update=false) {
      if (!update && pendingCounter) { return pendingCounter; }
      if (!update && state.loaded) { return state.counterData; }
      const request = ++counterRequest;
      const pending = axios.get('/api/counter/').then(response => {
        if (response.data?.status !== 'success' || !response.data.data?.basket || !response.data.data?.favorite) {
          throw new Error('Не удалось обновить корзину и избранное');
        }
        if (request === counterRequest) {
          commit('SET_COUNTER_DATA', response.data.data);
          commit('SET_ERROR', null);
        }
        return response.data.data;
      }).catch(error => {
        if (request === counterRequest) { commit('SET_ERROR', error.message); }
        return null;
      });
      pendingCounter = pending;
      try { return await pending; }
      finally { if (pendingCounter === pending) { pendingCounter = null; } }
    },

    // Force refresh method (optional) if you need to manually refresh the data
    async refreshCounterData({ commit, dispatch }) {
      commit('SET_LOADING', true);
      commit('SET_COUNTER_DATA', null);
      commit('SET_ERROR', null);
      commit('RESET_LOADED_STATE');
      await dispatch('fetchCounterData');
    }
  },
  getters: {
    counterData: state => state.counterData,
    counterBasketData: state => state.counterBasketData,
    counterFavoriteData: state => state.counterFavoriteData,
    counterPushData: state => state.counterPushData,
    counterLoading: state => state.counter_loading,
    counterError: state => state.counter_error,
    counterLoaded: state => state.counter_loaded
  }
}
